import styled from 'styled-components';
import { opacityModifier } from '@/utils';
import { DialogContainerProps } from './dialogContainer.types';

export const Container = styled.div<{ $position: DialogContainerProps['position'] }>`
  width: ${({ $position }) => ($position === 'absolute' ? '100%' : '100vw')};
  height: ${({ $position }) => ($position === 'absolute' ? '100%' : '100vh')};

  display: flex;
  align-items: center;
  justify-content: center;

  position: ${({ $position }) => $position};
  top: 0;
  left: 0;
  z-index: 9999;
`;

export const ChildrenWrapper = styled.div<{ $open: boolean }>`
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  position: relative;
  transition: all 150ms;
  z-index: 2;
`;

export const Overlay = styled.div<{ $open: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  transition: all 150ms;

  background-color: ${({ theme: { color }, $open }) =>
    $open ? opacityModifier(color.ui6, 0.7) : 'transparent'};
  backdrop-filter: ${({ $open }) => `blur(${$open ? 16 : 0}px)`};
  -webkit-backdrop-filter: ${({ $open }) => `blur(${$open ? 16 : 0}px)`};
`;
